import React from 'react';

import { MODE_ICON_PATH } from './ModeIcon';

/** A delivery truck: the Road mode on the Saved tab. */
const TruckIcon: React.FC = () => (
  <svg width='16' height='16' viewBox='0 0 24 24' fill='none' aria-hidden>
    <path
      d={MODE_ICON_PATH.road}
      stroke='currentColor'
      strokeWidth='1.6'
      fill='none'
    />
  </svg>
);

export default TruckIcon;
